import React, { useState, useEffect } from 'react';
import useHttp from "../../../../hook/use-http";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates_bus";
import moment from "moment";
import WaterMark from "../../../Dashboard/DashboardMain/WaterMark";
import NoData from "../../Driveanalysis_Bus/NoData_Bus";
import ChartLoader from "../../Driveanalysis_Bus/ChartLoader";
import { Line } from "react-chartjs-2";
import * as $ from "jquery";
// import 'chartjs-plugin-datalabels';

export default function FaultFirstGraph(props) {

  const [faultSelected, setFaultSelected] = useState("day");
  const [topping, setTopping] = useState("Fault");
  const [faultSelected_unit, setFaultSelected_unit] = useState("BMS");
  const [dataVehicale, setDataVehicale] = useState([]);
  const [dataVehicaleday, setDataVehicaleday] = useState([]);

  const { isLoading, error, sendReq: fetchData } = useHttp();
  let { title, template_id, show, soarting, gloablfilter, IND } = props;
  let temp = [];

  const [LineContainerBody_Fault, setCssLineCont] = useState({
    height: "335px",
  });

  useEffect(() => {
    setTopping("Fault")
    setFaultSelected("day");
    fetchData(
      {
        url: API_URL_MAIN + "faultfirstpage_bus/faultyvehicledaywise_bus",
        body: { filterdata: gloablfilter, IND, defaultNav: faultSelected_unit },
      },
      responceDataDate
    );
  }, [gloablfilter]);

  useEffect(() => {
    if (dataVehicale.length > 0) {
      fetchData(
        {
          url: API_URL_MAIN + "faultfirstpage_bus/faultyvehicletotal_bus",
          body: { filterdata: gloablfilter, IND },
        },
        responceDataTotalVehicale
      );
    }
  }, [dataVehicale]);

  useEffect(() => {
    setTopping("Fault")
    $("canvas").css("display", "");

    if (topping === "Fault" && faultSelected === "day") {

    }
    if (topping === "Alarm" && faultSelected === "month") {
    }
    if (topping === "Alarm" && faultSelected === "day") {
      fetchData(
        {
          url: API_URL_MAIN + "faultfirstpage_bus/faultyvehicledaywise_bus",
          body: { filterdata: gloablfilter, IND },
        },
        responceDataVehicaleday
      );
    }
  }, [gloablfilter]);

  const [falutTrigger, setFaultTrigger] = useState({
    labels: [],
    datasets: [],
    options: {
      plugins: {
        datalabels: {
          display: false,
        },
        legend: {
          display: false // Hide the legend
        },
        tooltip: {
          enabled: true // Disable tooltip
        }
      },
      scales: {
        y: {
          grid: {
            display: false,
          },
        },
        x: {
          grid: {
            display: false,
          },
        },
      },
      maintainAspectRatio: false,
    },
  });

  const getMonths = (fromDate, toDate) => {
    const fromYear = fromDate.getFullYear();
    let fromMonth = fromDate.getMonth();
    const toYear = toDate.getFullYear();
    let toMonth = toDate.getMonth();
    const months = [];

    for (let year = fromYear; year <= toYear; year++) {
      let monthNum = year === fromYear ? fromMonth : 0;
      const monthLimit = year === toYear ? toMonth : 11;

      for (; monthNum <= monthLimit; monthNum++) {
        let month = monthNum + 1;
        month = month < 10 ? "0" + month : "" + month;
        year = year.toString();
        let yeamon = year.concat(month);
        months.push(yeamon);
      }
    }
    return months;
  };

  function getMonthName(monthNumber) {
    const date = new Date();
    date.setMonth(monthNumber - 1);
    return date.toLocaleString("en-US", { month: "short" });
  }

  function datesArray(start, end) {
    let result = [],
      current = new Date(start);
    while (current <= end)
      result.push(current) &&
        (current = new Date(current)) &&
        current.setDate(current.getDate() + 1);

    for (let i = 0; i < result.length; i++) {
      temp.push(result[i].toISOString().slice(0, 10));
    }
    return temp;
  }

  const changeFaultTrigger = (selectOp) => {
    setFaultSelected(selectOp);
    const faultSelected1 = selectOp;
    if (topping === "Fault" && faultSelected1 === "month") {
      fetchData(
        {
          url:
            API_URL_MAIN + "faultfirstpage_bus/faultyvehiclemonthwisefault_bus",
          body: {
            filterdata: gloablfilter,
            IND,
            defaultNav: faultSelected_unit,
          },
        },
        responceData
      );
    }
    if (topping === "Fault" && faultSelected1 === "day") {
      fetchData(
        {
          url: API_URL_MAIN + "faultfirstpage_bus/faultyvehicledaywise_bus",
          body: {
            filterdata: gloablfilter,
            IND,
            defaultNav: faultSelected_unit,
          },
        },
        responceDataDate
      );
    }

    if (topping === "Alarm" && faultSelected1 === "month") {
      fetchData(
        {
          url:
            API_URL_MAIN + "faultfirstpage_bus/faultyvehiclemonthwisefault_bus",
          body: {
            filterdata: gloablfilter,
            IND,
            defaultNav: faultSelected_unit,
          },
        },
        responceDataVehicale
      );
    }

    if (topping === "Alarm" && faultSelected1 === "day") {
      fetchData(
        {
          url: API_URL_MAIN + "faultfirstpage_bus/faultyvehicledaywise_bus",
          body: {
            filterdata: gloablfilter,
            IND,
            defaultNav: faultSelected_unit,
          },
        },
        responceDataVehicaleday
      );
    }
  };

  const responceData = (dataRes, LableName) => {
    if (dataRes.length > 0) {
      let lableName = LableName;
      let defaultArr = [];
      let defaultArr1 = [];
      defaultArr1 = dataRes;
      let colorArr = ["#83a4cf", "#4c95b0", "#62a3ba", "#79b0c4", "#8fbdce"];
      if (lableName === undefined) lableName = "Faultly vehicle count";
      if (lableName === "Faultly vehicle count")
        defaultArr.push({
          label: "Count",
          data: [],
          fill: false,
          borderColor: colorArr[0],
        });
      else
        defaultArr.push({
          label: "% Count",
          data: [],
          fill: false,
          borderColor: colorArr[0],
        });

      let st = moment(new Date(props.gloablfilter.startDate)).format(
        "YYYY-MM-DD"
      );
      let ed = moment(new Date(props.gloablfilter.endDate)).format(
        "YYYY-MM-DD"
      );
      const dateArr = getMonths(new Date(st), new Date(ed));
      for (let q = 0; q < dateArr.length; q++) {
        dataRes.forEach((obj1) => {
          if (dateArr[q] === obj1.key.monthId) {
            for (let t = 0; t < defaultArr.length; t++) {
              defaultArr[t].data.push(obj1.Faulty_vehicle.value);
            }
          }
        });

        let count = 0;
        for (let pt = 0; pt < defaultArr.length; pt++) {
          if (defaultArr[pt].data.length > count) {
            count = defaultArr[pt].data.length;
          }
        }

        for (let xt = 0; xt < defaultArr.length; xt++) {
          if (defaultArr[xt].data.length !== count) {
            defaultArr[xt].data.push(0);
          }
        }
      }

      var bags = [];
      let monthArray = [];
      dataRes.map(({ key, i }) => {
        let year = key.monthId.substring(0, 4);
        let month = key.monthId.substring(4);
        let monthYear = getMonthName(month) + "-" + year;
        monthArray.indexOf(monthYear) === -1 && monthArray.push(monthYear);
      });
      const data = {
        labels: monthArray,
        datasets: defaultArr,
        options: {
          plugins: {
            datalabels: {
              display: false,
            },
            legend: {
              display: false // Hide the legend
            },
            tooltip: {
              enabled: true // Disable tooltip
            }
          },
          // plugins: {
          //   legend: {
          //     display: false,
          //   },
          // },
          scales: {
            y: {
              grid: {
                display: false,
              },
              title: {
                display: true,
                text: lableName,
              },
            },
            x: {
              grid: {
                display: false,
              },
              title: {
                display: true,
                text: "Month",
              },
            },
          },
          maintainAspectRatio: false,
        },
      };

      setFaultTrigger(data);
    } else {
      setFaultTrigger({
        labels: [],
        datasets: [],
        options: {
          plugins: {
            datalabels: {
              display: false,
            },
            legend: {
              display: false // Hide the legend
            },
            tooltip: {
              enabled: true // Disable tooltip
            }
          },
          scales: {
            y: {
              grid: {
                display: false,
              },
              title: {
                display: true,
                text: "Fault count",
              },
            },
            x: {
              grid: {
                display: false,
              },
              title: {
                display: true,
                text: "Month",
              },
            },
          },
          maintainAspectRatio: false,
        },
      });
    }
  };

  function responceDataDate(dataDate, LableName) {
    if (dataDate.length > 0) {
      let lableName = LableName;
      let defaultArr = [];
      let defaultArr1 = dataDate;
      let colorArr = ["#7794b8", "#4c95b0", "#62a3ba", "#79b0c4", "#8fbdce"];
      if (lableName === undefined) lableName = "Faultly vehicle count";
      if (lableName === "Faultly vehicle count")
        defaultArr.push({
          label: "Count",
          data: [],
          fill: false,
          borderColor: colorArr[0],
        });
      else
        defaultArr.push({
          label: "% Count",
          data: [],
          fill: false,
          borderColor: colorArr[0],
        });

      const dateArr = datesArray(
        new Date(props.gloablfilter.startDate),
        new Date(props.gloablfilter.endDate)
      );

      for (let q = 0; q < dateArr.length; q++) {
        dataDate.forEach((obj1) => {
          if (dateArr[q] === obj1.key.eventdate) {
            for (let t = 0; t < defaultArr.length; t++) {
              defaultArr[t].data.push(obj1.Faulty_vehicle.value);
            }
          }
        });

        let count = 0;
        for (let pt = 0; pt < defaultArr.length; pt++) {
          if (defaultArr[pt].data.length > count) {
            count = defaultArr[pt].data.length;
          }
        }

        for (let xt = 0; xt < defaultArr.length; xt++) {
          if (defaultArr[xt].data.length !== count) {
            defaultArr[xt].data.push(0);
          }
        }
      }

      let monthArrayD = [];

      dataDate.map(({ key, i }) => {
        monthArrayD.indexOf(key.eventdate) === -1 &&
          monthArrayD.push(key.eventdate);
      });

      const data = {
        labels: monthArrayD,
        datasets: defaultArr,
        options: {
          plugins: {
            datalabels: {
              display: false,
            },
            legend: {
              display: false,
            },
            tooltip: {
              enabled: true // Disable tooltip
            }
          },
          scales: {
            y: {
              grid: {
                display: false,
              },
              title: {
                display: true,
                text: lableName,
              },
            },
            x: {
              grid: {
                display: false,
              },
              title: {
                display: true,
                text: "Day",
              },
            },
          },
          maintainAspectRatio: false,
        },
      };
      setFaultTrigger(data);

    } else {
      setFaultTrigger({
        labels: [],
        datasets: [],
        options: {
          plugins: {
            datalabels: {
              display: false,
            },
            legend: {
              display: false // Hide the legend
            },
            tooltip: {
              enabled: true // Disable tooltip
            }
          },
          scales: {
            y: {
              grid: {
                display: false,
              },
              title: {
                display: true,
                text: "Fault count",
              },
            },
            x: {
              grid: {
                display: false,
              },
              title: {
                display: true,
                text: "Month",
              },
            },
          },
          maintainAspectRatio: false,
        },
      });
    }
  }

  function responceDataVehicale(data) {
    let arraydata = [];
    data.forEach((obj1) => {
      arraydata.push({
        monthId: obj1.key.monthId,
        faulty_vehicle: obj1.Faulty_vehicle.value,
      });
    });
    if (data.length > 0) {
      setDataVehicale(arraydata);
    } else {
      falutTrigger.datasets.length = 0;
      setDataVehicale([]);
    }
  }

  function responceDataVehicaleday(data) {
    let arraydata = [];
    data.forEach((obj1) => {
      arraydata.push({
        eventdate: obj1.key.eventdate,
        Faulty_vehicle: obj1.Faulty_vehicle.value,
      });
    });
    if (data.length > 0) {
      setDataVehicaleday(arraydata);
    } else {
      falutTrigger.datasets.length = 0;
      setDataVehicaleday([]);
    }
  }

  const changeFaultTrigger_unit = (selectOp) => {
    setFaultSelected_unit(selectOp);
    const faultSelected_units = selectOp;
    if (topping === "Fault" && faultSelected === "month") {
      fetchData(
        {
          url:
            API_URL_MAIN + "faultfirstpage_bus/faultyvehiclemonthwisefault_bus",
          body: {
            filterdata: gloablfilter,
            IND,
            defaultNav: faultSelected_units,
          },
        },
        responceData
      );
    }
    if (topping === "Fault" && faultSelected === "day") {
      fetchData(
        {
          url: API_URL_MAIN + "faultfirstpage_bus/faultyvehicledaywise_bus",
          body: {
            filterdata: gloablfilter,
            IND,
            defaultNav: faultSelected_units,
          },
        },
        responceDataDate
      );
    }

    if (topping === "Alarm" && faultSelected === "month") {
      fetchData(
        {
          url:
            API_URL_MAIN + "faultfirstpage_bus/faultyvehiclemonthwisefault_bus",
          body: {
            filterdata: gloablfilter,
            IND,
            defaultNav: faultSelected_units,
          },
        },
        responceDataVehicale
      );
      // fetchData(
      //   {
      //     url: API_URL_MAIN + "faultfirstpage_bus/faultyvehicletotal_bus",
      //     body: { filterdata: gloablfilter, IND },
      //   },
      //   responceDataTotalVehicale
      // );
    }
    if (topping === "Alarm" && faultSelected === "day") {
      fetchData(
        {
          url: API_URL_MAIN + "faultfirstpage_bus/faultyvehicledaywise_bus",
          body: {
            filterdata: gloablfilter,
            IND,
            defaultNav: faultSelected_units,
          },
        },
        responceDataVehicaleday
      );
    }
  };

  const onRadioChange = (e) => {
    setTopping(e.target.value);
    const topping1 = e.target.value;

    if (topping1 === "Fault" && faultSelected === "month") {
      fetchData(
        {
          url:
            API_URL_MAIN + "faultfirstpage_bus/faultyvehiclemonthwisefault_bus",
          body: {
            filterdata: gloablfilter,
            IND,
            defaultNav: faultSelected_unit,
          },
        },
        responceData
      );
    }
    if (topping1 === "Fault" && faultSelected === "day") {
      fetchData(
        {
          url: API_URL_MAIN + "faultfirstpage_bus/faultyvehicledaywise_bus",
          body: {
            filterdata: gloablfilter,
            IND,
            defaultNav: faultSelected_unit,
          },
        },
        responceDataDate
      );
    }

    if (topping1 === "Alarm" && faultSelected === "month") {
      fetchData(
        {
          url:
            API_URL_MAIN + "faultfirstpage_bus/faultyvehiclemonthwisefault_bus",
          body: {
            filterdata: gloablfilter,
            IND,
            defaultNav: faultSelected_unit,
          },
        },
        responceDataVehicale
      );
      fetchData(
        {
          url: API_URL_MAIN + "faultfirstpage_bus/faultyvehicletotal_bus",
          body: { filterdata: gloablfilter, IND },
        },
        responceDataTotalVehicale
      );
    }

    if (topping1 === "Alarm" && faultSelected === "day") {
      fetchData(
        {
          url: API_URL_MAIN + "faultfirstpage_bus/faultyvehicledaywise_bus",
          body: {
            filterdata: gloablfilter,
            IND,
            defaultNav: faultSelected_unit,
          },
        },
        responceDataVehicaleday
      );
    }
  };

  function responceDataTotalVehicale(data) {
    let arraydata = [];
    let percentarray = [];
    let percent = 0;
    const lableName = "Percentage of faultly vehicle";
    data.forEach((obj1) => {
      arraydata.push({
        monthId: obj1.key.monthId,
        total_vehicle: obj1.Total_vehicle_count.value,
      });
    });
    arraydata.forEach((obj1, i) => {
      percent = 0;
      if (obj1.monthId === dataVehicale[i].monthId) {
        percent = (dataVehicale[i].faulty_vehicle / obj1.total_vehicle) * 100;
        percentarray.push({ monthId: obj1.monthId, faulty_vehicle: percent });
      }
    });
    let perarray = [];
    percentarray.forEach((obj1, i) => {
      perarray.push({
        key: { monthId: obj1.monthId },
        Faulty_vehicle: { value: obj1.faulty_vehicle },
      });
    });
    responceData(perarray, lableName);
  }

    function responceDataTotalVehicaleday(data) {
        let arraydata = [];
        let percentarray = [];
        let percent = 0;
    
        data.forEach((obj1) => {
          arraydata.push({
            eventdate: obj1.key.eventdate,
            total_vehicle: obj1.Total_vehicle_count.value,
          });
        });
        arraydata.forEach((obj1, i) => {
          // if (obj1.eventdate === dataVehicaleday[i].eventdate) {
          //   percent = (dataVehicaleday[i].Faulty_vehicle / obj1.total_vehicle) * 100;
          //   percentarray.push({
          //     eventdate: obj1.eventdate,
          //     Faulty_vehicle: percent,
          //   });
          // }
          
          for (let x = 0; x < dataVehicaleday.length; x++) {
            if (dataVehicaleday[x].eventdate === obj1.eventdate) {
              percent = (dataVehicaleday[x].Faulty_vehicle / obj1.total_vehicle) * 100;
              percentarray.push({
                eventdate: obj1.eventdate,
                Faulty_vehicle: percent,
              });
            }
          }
        });
        let perarray = [];
        percentarray.forEach((obj1, i) => {
          perarray.push({
            key: { eventdate: obj1.eventdate },
            Faulty_vehicle: { value: obj1.Faulty_vehicle },
          });
        });
    
        responceDataDate(perarray, "Percentage of faulty vehicle");
      }

  useEffect(() => {
    if (dataVehicaleday.length > 0) {
      fetchData(
        {
          url:
            API_URL_MAIN +
            "faultfirstpage_bus/percentagefaultyvehicaldaywise_bus",
          body: { filterdata: gloablfilter, IND },
        },
        responceDataTotalVehicaleday
      );
    }
  }, [dataVehicaleday]);

  return (
    <div className="col-md-12 col-lg-6 col-sm-12 pr-0 mb-3">
      <div className="v-title chartbox3">
        <div className="row mb-1 titlebg_bus_fault">
          <div className="col-md-12 col-sm-6 col-lg-5">
            <div className="text-fit">Percentage of faulty vehicle</div>
          </div>
          <div className="col-md-6 col-sm-6 col-lg-3 py-1">
            <select
              className="form-select form-select-sm"
              aria-label="Default select example"
              onChange={(event) => changeFaultTrigger(event.target.value)}
              value={faultSelected}
            >
              <option value="month">Month</option>
              <option value="day">Day</option>
            </select>
          </div>
          <div className="col-md-12 col-sm-6 col-lg-3 py-1">
            <select
              className="form-select form-select-sm"
              aria-label="Default select example"
              onChange={(event) => changeFaultTrigger_unit(event.target.value)}
              value={faultSelected_unit}
            >
              <option value="BCS-1">BCS-1</option>
              <option value="BCS-2">BCS-2</option>
              <option value="MCU">MCU</option>
              <option value="VCU">VCU</option>
              <option value="Aux-1">Aux-1</option>
              <option value="Aux-2">Aux-2</option>
              <option value="BMS">BMS</option>
              <option value="HVAC">HVAC</option>
              <option value="DC-DC">DC-DC</option>
            </select>
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-md-6 col-sm-6 col-lg-8 py-1">
            <div className="form-check form-check-inline bus">
              <input
                className="form-check-input"
                type="radio"
                name="FaultyVehicleCount"
                id="FaultyVehicleCount"
                value="Fault"
                checked={topping === "Fault"}
                onClick={onRadioChange}
              />
              <label className="form-check-label" htmlFor="FaultyVehicleCount">
                Faulty vehicle count
              </label>
            </div>
            <div className="form-check form-check-inline bus">
              <input
                className="form-check-input"
                type="radio"
                name="FaultyVehicleCount"
                id="PercentageOfFaultyVehicle"
                value="Alarm"
                checked={topping === "Alarm"}
                onClick={onRadioChange}
              />
              <label
                className="form-check-label"
                htmlFor="PercentageOfFaultyVehicle"
              >
                Percentage of faulty vehicle
              </label>
            </div>
          </div>
        </div>

        <div className="row mb-2">
          <div className="chartHGT">
            <WaterMark />
            <div style={{ width: "auto", maxWidth: "auto" }}>
              <div
                style={LineContainerBody_Fault}
                className="LineContainerBody_Fault"
              >
                {isLoading ? (
                  <ChartLoader />
                ) : falutTrigger.datasets.length > 0 ? (
                  <Line data={falutTrigger} options={falutTrigger.options} />
                ) : (
                  <NoData />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}